module.exports = __webpack_public_path__ + "img/montserrat-v15-latin-700italic.d4836763.svg";